// src/router.tsx
import { createRouter as createTanStackRouter } from '@tanstack/react-router';
// eslint-disable-next-line import/extensions
import { routeTree } from './routeTree.gen';

export function createRouter() {
  const router = createTanStackRouter({
    context: {
      isAuthenticated: false, // Default value, can be updated based on authentication state
    },
    routeTree,
    scrollRestoration: true,
    defaultPendingMs: 0,
    defaultGcTime: 0,
    defaultPreload: false,
  });

  return router;
}

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}